import type { QueryClient } from "@tanstack/react-query";

export function invalidateAttendance(queryClient: QueryClient) {
	queryClient.invalidateQueries({ queryKey: ["attendance"] });
	queryClient.invalidateQueries({ queryKey: ["time-entries"] });
}
